import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useApi, PageHeader, Loading, Card, RangePicker, rangeQuery, Empty, TableWrap } from "../components/common";
import { inr, pct, num } from "../lib/format";

function Designers() {
  const [range, setRange] = useState({ range: "this_month" });
  const ready = range.range !== "custom" || (range.start && range.end);
  const { data, loading } = useApi(ready ? `/performance/designers?${rangeQuery(range)}` : null);
  return (
    <Card title="Designer Performance (owner only)" actions={<RangePicker value={range} onChange={setRange} />} testid="designer-performance">
      <TableWrap>{loading && !data ? <Loading /> : !data?.items.length ? <Empty text="No designers" /> : (
        <table className="vmw-table" data-testid="designer-performance-table">
          <thead><tr><th>Designer</th><th>Assigned</th><th>Active</th><th>Completed</th><th>Sheets Done</th><th>Sheets In Progress</th><th>Tasks Done</th><th>Open Tasks</th><th>Overdue</th><th>Avg Turnaround</th><th>Revisions</th></tr></thead>
          <tbody>{data.items.map((d) => (
            <tr key={d.user_id} data-testid={`designer-perf-${d.user_id}`}><td className="font-medium">{d.name}{!d.is_active && <span className="text-xs text-rose-500"> (inactive)</span>}</td>
              <td>{d.projects_assigned}</td><td>{d.active_projects}</td><td>{d.projects_completed}</td><td className="font-semibold text-primary">{num(d.sheets_completed)}</td><td>{num(d.sheets_in_progress)}</td>
              <td>{d.tasks_completed}</td><td>{d.open_tasks}</td><td className={d.overdue_tasks ? "text-rose-600 font-semibold" : ""}>{d.overdue_tasks}</td>
              <td>{d.avg_turnaround_days == null ? "—" : `${d.avg_turnaround_days} days`}</td><td>{d.task_revisions} task · {d.project_revisions_in_period} project</td></tr>))}</tbody>
        </table>)}</TableWrap>
      <p className="text-xs text-muted-foreground mt-2">Calculated from actual project and task records. Sheets on multi-designer projects are split evenly.</p>
    </Card>
  );
}

function Sales() {
  const { data, loading } = useApi("/sales/performance");
  return (
    <Card title="Sales Performance (all time)" testid="sales-performance">
      <TableWrap>{loading && !data ? <Loading /> : !data?.length ? <Empty text="No sales executives" /> : (
        <table className="vmw-table" data-testid="sales-performance-table">
          <thead><tr><th>Salesperson</th><th>Leads</th><th>Open</th><th>Won</th><th>Lost</th><th>Won Value</th><th>Conversion</th><th>Target</th><th>Achieved</th><th>Activities</th></tr></thead>
          <tbody>{data.map((s) => (
            <tr key={s.user_id}><td className="font-medium">{s.name}</td><td>{s.leads}</td><td>{s.open_leads}</td><td>{s.won}</td><td>{s.lost}</td><td className="font-semibold">{inr(s.won_value)}</td>
              <td>{pct(s.conversion_pct)}</td><td>{s.target ? inr(s.target) : "—"}</td><td>{pct(s.target_pct)}</td><td>{s.activities}</td></tr>))}</tbody>
        </table>)}</TableWrap>
    </Card>
  );
}

export default function Performance() {
  const { user } = useAuth();
  return (
    <div className="space-y-6">
      <PageHeader title="Performance" subtitle={user.role === "owner" ? "Team productivity from real records" : "Your sales performance"} />
      <Sales />
      {user.role === "owner" && <Designers />}
    </div>
  );
}
